/**
 * Portrait logical resolution. All game code works in these units; the
 * viewport scales them to the real screen (letterboxed, crisp on HiDPI).
 */
export const GAME_WIDTH = 360;
export const GAME_HEIGHT = 640;

export interface Fit {
  /** CSS pixels per game unit. */
  scale: number;
  cssWidth: number;
  cssHeight: number;
}

/** Largest uniform scale that fits the game area inside the given box. */
export function fitToBox(boxWidth: number, boxHeight: number): Fit {
  const scale = Math.max(0.1, Math.min(boxWidth / GAME_WIDTH, boxHeight / GAME_HEIGHT));
  return { scale, cssWidth: GAME_WIDTH * scale, cssHeight: GAME_HEIGHT * scale };
}

/** Resize the canvas to fill its container and return a context in game units. */
export function applyFit(canvas: HTMLCanvasElement, fit: Fit, dpr: number): CanvasRenderingContext2D {
  canvas.style.width = `${fit.cssWidth}px`;
  canvas.style.height = `${fit.cssHeight}px`;
  canvas.width = Math.round(fit.cssWidth * dpr);
  canvas.height = Math.round(fit.cssHeight * dpr);
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas 2D not supported');
  ctx.setTransform(fit.scale * dpr, 0, 0, fit.scale * dpr, 0, 0);
  return ctx;
}
